import ActionType from 'actions/ActionType'
// import { themeObj } from 'components/withRoot'
import { capitalize } from 'lodash'

const initialState = (preferences, currentState = {}) => ({
  formName: {
    value: currentState.formName?.value || '',
    initialValue: currentState.formName?.initialValue || '',
  },
  title: {
    value: currentState.title?.value || '',
    initialValue: currentState.title?.initialValue || '',
  },
  // Repeat for other properties, merging preferences and currentState
  titleTextColor: {
    value:
      preferences?.form_color_text_title ||
      currentState.titleTextColor?.value ||
      '#000000',
    initialValue:
      preferences?.form_color_text_title ||
      currentState.titleTextColor?.initialValue ||
      '#000000',
  },
  description: {
    value: currentState.description?.value || '',
    initialValue: currentState.description?.initialValue || '',
  },
  descriptionTextColor: {
    value:
      preferences?.form_color_text_description ||
      currentState.descriptionTextColor?.value ||
      '#000000',
    initialValue:
      preferences?.form_color_text_description ||
      currentState.descriptionTextColor?.initialValue ||
      '#000000',
  },
  backgroundColor: {
    value:
      preferences?.form_color_background ||
      currentState.backgroundColor?.value ||
      '#fafafa',
    initialValue:
      preferences?.form_color_background ||
      currentState.backgroundColor?.initialValue ||
      '#fafafa',
  },
  buttonText: {
    value: currentState.buttonText?.value || 'Subscribe',
    initialValue: currentState.buttonText?.initialValue || 'Subscribe',
  },
  buttonTextColor: {
    value:
      preferences?.form_color_button_text ||
      currentState.buttonTextColor?.value ||
      '#ffffff',
    initialValue:
      preferences?.form_color_button_text ||
      currentState.buttonTextColor?.initialValue ||
      '#ffffff',
  },
  buttonBackgroundColor: {
    value:
      preferences?.form_color_button_background ||
      currentState.buttonBackgroundColor?.value ||
      '#014c94',
    initialValue:
      preferences?.form_color_button_background ||
      currentState.buttonBackgroundColor?.initialValue ||
      '#014c94',
  },
  font: {
    value: preferences?.form_font || currentState.font?.value || 'Arial',
    initialValue:
      preferences?.form_font || currentState.font?.initialValue || 'Arial',
  },
  textColor: {
    value:
      preferences?.form_color_text_label ||
      currentState.textColor?.value ||
      '#000000',
    initialValue:
      preferences?.form_color_text_label ||
      currentState.textColor?.initialValue ||
      '#000000',
  },
  // Other initial properties...
  embedType: {
    value: currentState.embedType?.value || 'embedded',
    initialValue: currentState.embedType?.initialValue || 'embedded',
  },
  logoURL: {
    value: currentState.logoURL?.value || '',
    initialValue: currentState.logoURL?.initialValue || '',
  },
  landingPageContent: {
    value:
      currentState.landingPageContent?.value ||
      `<p style="text-align: center;"><span style="font-family: Arial, Helvetica, sans-serif; color: rgba(46, 84, 150, 1); font-size: x-large;">Thank you for submitting this form!</span></p>`,
    initialValue:
      currentState.landingPageContent?.initialValue ||
      `<p style="text-align: center;"><span style="font-family: Arial, Helvetica, sans-serif; color: rgba(46, 84, 150, 1); font-size: x-large;">Thank you for submitting this form!</span></p>`,
  },
  landingPageURL: {
    value: currentState.landingPageURL?.value || '',
    initialValue: currentState.landingPageURL?.initialValue || '',
  },
})

// Helper function to process form payload
function processFormPayload(payload) {
  const {
    name,
    title,
    background_color,
    button,
    description,
    display_type,
    font,
    text_color,
    logo_url,
  } = payload
  return {
    formName: { value: name, initialValue: name },
    title: { value: title.text, initialValue: title.text },
    titleTextColor: { value: title.color, initialValue: title.color },
    description: { value: description.text, initialValue: description.text },
    descriptionTextColor: {
      value: description.color,
      initialValue: description.color,
    },
    backgroundColor: {
      value: background_color,
      initialValue: background_color,
    },
    buttonText: { value: button.text, initialValue: button.text },
    buttonTextColor: {
      value: button.text_color,
      initialValue: button.text_color,
    },
    buttonBackgroundColor: {
      value: button.background_color,
      initialValue: button.background_color,
    },
    font: { value: capitalize(font), initialValue: capitalize(font) },
    textColor: { value: text_color, initialValue: text_color },
    embedType: { value: display_type, initialValue: display_type },
    logoURL: { value: logo_url || '', initialValue: logo_url || '' },
    // Additional payload processing as needed...
  }
}

export default (state = { ...initialState(), preferences: null }, action) => {
  switch (action.type) {
    case ActionType.Data.READ_SUCCESS:
      if (action.entityType === 'account/preference') {
        return {
          ...state,
          ...initialState(action.payload?.preferences, state),
        }
      }
      return state
    case ActionType.SignupForm.SELECT_FORM_TYPE:
      if (action.payload === 'signup') {
        return {
          ...state,
          buttonText: { value: 'Subscribe', initialValue: 'Subscribe' },
        }
      }

      if (action.payload === 'custom') {
        return {
          ...state,
          buttonText: { value: 'Submit', initialValue: 'Submit' },
        }
      }

      return state
    case ActionType.PREDICTIONS.INGEST_PREDICTION:
      if (action?.intent === 'createSignupForm') {
        const nameEntityArr = action?.payload?.filter?.(
          el => el.type === 'TITLE',
        )
        const embedTypeArr = action?.payload?.filter?.(
          el => el.type === 'embedType',
        )

        if (nameEntityArr.length) {
          return {
            ...state,
            formName: {
              ...state.formName,
              value: nameEntityArr?.[0]?.entity || state.formName,
            },
            title: {
              ...state.title,
              value: nameEntityArr?.[0]?.entity || state.title,
            },
            embedType: {
              ...state.embedType,
              value:
                embedTypeArr?.[0]?.entity?.includes('pop') ||
                embedTypeArr?.[0]?.entity?.includes('modal')
                  ? 'popover'
                  : 'embedded',
            },
          }
        }
      }
      return state
    case ActionType.SignupForm.HANDLE_FORM_VALUE_CHANGE:
      return {
        ...state,
        [action.property]: {
          initialValue: state[action.property].initialValue,
          value: action.payload,
        },
      }
    case 'setLogoForms':
      return {
        ...state,
        logoURL: {
          initialValue: action.payload,
          value: action.payload,
        },
      }
    case ActionType.SignupForm.RECEIVE_FORM:
      if (action.payload) {
        // Assume modifications are made here to integrate the form payload...
        return {
          ...initialState(state.preferences, state),
          ...processFormPayload(action.payload),
        }
      }
      return state
    case ActionType.CustomForm.RECEIVE_FORM:
      if (action.payload) {
        const {
          name,
          // title,
          background_color,
          // submit_button,
          // description,
          display_type,
          font,
          text_color,
          logo_url,
          landing_page,
        } = action.payload

        const submit_button =
          action.payload?.submit_button || action.payload?.button

        return {
          formName: { value: name, initialValue: name },
          title: {
            value: action?.payload?.title?.text || '',
            initialValue: action?.payload?.title?.text || '',
          },
          titleTextColor: {
            value: action?.payload?.title?.color || '#000000',
            initialValue: action?.payload?.title?.color || '#000000',
          },
          description: {
            value: action?.payload?.description?.text || '',
            initialValue: action?.payload?.description?.text || '',
          },
          descriptionTextColor: {
            value: action?.payload?.description?.color || '#000000',
            initialValue: action?.payload?.description?.color || '#000000',
          },
          backgroundColor: {
            value: background_color,
            initialValue: background_color,
          },
          buttonText: {
            value: submit_button?.text,
            initialValue: submit_button?.text,
          },
          buttonTextColor: {
            value: submit_button?.text_color,
            initialValue: submit_button?.text_color,
          },
          buttonBackgroundColor: {
            value: submit_button?.background_color,
            initialValue: submit_button?.background_color,
          },
          font: { value: capitalize(font), initialValue: capitalize(font) },
          textColor: { value: text_color, initialValue: text_color },
          embedType: { value: display_type, initialValue: display_type },
          logoURL: { value: logo_url || '', initialValue: logo_url || '' },
          landingPageContent: {
            value: landing_page?.content?.HtmlPart || '',
            initialValue: landing_page?.content?.HtmlPart || '',
          },
          landingPageURL: {
            value: landing_page?.url || '',
            initialValue: landing_page?.url || '',
          },
        }
      }
      return { ...state, ...initialState(state.preferences) }
    case ActionType.SignupForm.VALIDATION_FAILURE:
      const dup = state
      const pathStateMap = {
        '/name': 'formName',
        '/title/color': 'titleTextColor',
        '/title/text': 'title',
        '/description/color': 'descriptionTextColor',
        '/description/text': 'description',
        '/display_type': 'embedType',
        '/button/text': 'buttonText',
        '/button/text_color': 'buttonTextColor',
        '/button/background_color': 'buttonBackgroundColor',
        '/text_color': 'textColor',
        '/font': 'font',
        '/logo_url': 'logoURL',
      }

      action.errors.forEach((error, idx) => {
        if (
          error.dataPath &&
          error.dataPath !== '/contactgroup_ids' &&
          pathStateMap[error.dataPath] &&
          dup[pathStateMap[error.dataPath]]
        ) {
          if (dup[pathStateMap[error.dataPath]].error) {
            dup[pathStateMap[error.dataPath]].error = `${
              dup[pathStateMap[error.dataPath]].error
            }, ${error.message}`
          } else {
            dup[pathStateMap[error.dataPath]].error = error.message
          }
        }
      })

      return dup
    default:
      return state
  }
}
